import { render, staticRenderFns } from "./DocumentosGenerales.vue?vue&type=template&id=a3b03e24"
import script from "./DocumentosGenerales.vue?vue&type=script&lang=js"
export * from "./DocumentosGenerales.vue?vue&type=script&lang=js"
import style0 from "./DocumentosGenerales.vue?vue&type=style&index=0&id=a3b03e24&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports